module.exports = __webpack_public_path__ + "img/724.96eeddc8.gif";